require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./peanut-butter-cookies-and-cream.json") })
        }
      }, "path---peanut-butter-cookies-and-cream");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---peanut-butter-cookies-and-cream!./.cache/json/peanut-butter-cookies-and-cream.json
// module id = 488
// module chunks = 231608221292675